import React from 'react'
import LandlordBooking from '../Components/LandlordBookings/LandlordBooking'

const BookingsLandlord = () => {
  return (
    <LandlordBooking />
  )
}

export default BookingsLandlord